module.exports = __webpack_public_path__ + "img/nolan-globe-earth.3002ce36.svg";